import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const IllustrationContainer = styled(motion.div)`
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 40%;
  height: 70%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

// SVG component for the parliament benches
const ParliamentBenches = () => (
  <svg 
    width="100%" 
    height="100%" 
    viewBox="0 0 800 600" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Top semi-circular benches */}
    {Array.from({ length: 5 }).map((_, i) => (
      <path
        key={`top-bench-${i}`}
        d={`M 150 ${150 + i * 30} 
            A 250 ${250 - i * 10} 0 0 1 650 ${150 + i * 30}`}
        stroke="rgba(255, 255, 255, 0.8)"
        strokeWidth="4"
        fill="none"
      />
    ))}

    {/* Bottom semi-circular benches */}
    {Array.from({ length: 5 }).map((_, i) => (
      <path
        key={`bottom-bench-${i}`}
        d={`M 150 ${450 - i * 30} 
            A 250 ${250 - i * 10} 0 0 0 650 ${450 - i * 30}`}
        stroke="rgba(255, 255, 255, 0.8)"
        strokeWidth="4"
        fill="none"
      />
    ))}

    {/* Central area */}
    <rect
      x="375"
      y="275"
      width="50"
      height="50"
      rx="5"
      fill="rgba(255, 255, 255, 0.6)"
    />

    {/* Small dots representing MPs on benches */}
    {Array.from({ length: 80 }).map((_, i) => {
      const angle = (i % 40) * (Math.PI / 20);
      const radius = i < 40 ? 200 + (i % 5) * 30 : 200 + (i % 5) * 30;
      const cx = 400 + Math.cos(angle) * radius;
      const cy = i < 40 ? 300 - Math.sin(angle) * radius : 300 + Math.sin(angle) * radius;
      
      return (
        <circle
          key={`mp-${i}`}
          cx={cx}
          cy={cy}
          r="4"
          fill="rgba(255, 255, 255, 0.9)"
        />
      );
    })}
  </svg>
);

const ParliamentIllustration = () => {
  return (
    <IllustrationContainer
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 1, delay: 0.5 }}
    >
      <ParliamentBenches />
    </IllustrationContainer>
  );
};

export default ParliamentIllustration;
